import React from "react";
import { Modal } from "antd";
import { ReactComponent as SuccessIcon } from "../../../assets/svgs/copy.svg";

const SuccessDialog = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      className="dialogBox text-center"
    >
      <div className="flex flex-col items-center gap-4 p-6">
        <SuccessIcon className="w-16 h-16" />
        <h2 className="text-lg font-semibold">Form Copied Successfully</h2>
        {/* <p className="text-sm text-gray-600">
          Please check the Dynamic Forms section to view and edit your copied
          form.
        </p> */}
      </div>
    </Modal>
  );
};

export default SuccessDialog;
